import { AppError } from '../../contracts/errors.js'

export function normalizeImageResponse(payload) {
  const images = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload?.images) ? payload.images : []
  const normalized = images.map((item) => typeof item === 'string' ? { url: item } : { url: item?.url || item?.b64_json || '', revisedPrompt: item?.revised_prompt || '' }).filter((item) => item.url)
  if (!normalized.length) throw new AppError('provider.empty-response', '服务未返回图片', { category: 'response' })
  return { images: normalized }
}
